import { ChartersRequestModel } from '@/modules/ChartersRequestModule/ChartersRequestForm/ChartersRequestForm.types';
import ApiService from '@/common/ApiService/ApiService';
import { HttpVerb } from '@/common/ApiService/HttpVerb';
import { AxiosResponse } from 'axios';

const ChartersRequestService = new ApiService('/api/ChartersRequestService/', {
  showLoading: true,
});

export const submitChartersRequestForm = (model: ChartersRequestModel): Promise<any> => {
  return ChartersRequestService.call('ChartersRequest', model, {
    verb: HttpVerb.POST,
    returnData: false,
  }).then((res: AxiosResponse) => {
    if (res.status == 200) {
      return { IsOk: true, Item: res.data, Error: null };
    }
    return { IsOk: false, Item: null, Error: res.data };
  });
};
